/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description flag modal actions
 */

import type { FlagModal } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import { RECEIVE_DATA } from '../constants/flagModal'

export const receiveData = createAction<
  Partial<Pick<FlagModal, 'entity'>> & Omit<FlagModal, 'entity'>,
  typeof RECEIVE_DATA
>(RECEIVE_DATA)
